import { render } from "./ChatInfoModal.vue?vue&type=template&id=ac5023a0&scoped=true"
import script from "./ChatInfoModal.vue?vue&type=script&lang=js"
export * from "./ChatInfoModal.vue?vue&type=script&lang=js"

import "./ChatInfoModal.vue?vue&type=style&index=0&id=ac5023a0&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-ac5023a0"]])

export default __exports__